import {ICompany} from "../../../index";
import {global, lm} from "../../../appContext";
import PromiseRequest from "../../../req/PromiseRequest";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {getHash, getRouteDefinition} from "../../../constants/RouteDefinitions";
import pubsub from "../../../pubsub";
import * as ko from "knockout";
import commentsHtml from './comments.html?raw';

export let template: string = commentsHtml;

export class viewModel {

    private req: PromiseRequest = new PromiseRequest('getcompany');
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private showComments = global.permissionValidator.isMinOrganizationAdmin
    private comments: KnockoutObservable<string | null> = ko.observable(null);
    private routeDef = getRouteDefinition('customercommentsdetails')!;
    private hash: KnockoutObservable<string | null> = ko.observable(getHash('customercommentsdetails'))


    constructor() {
        pubsub.on(this, 'company.comments.updated', this.initRequest.bind(this));
        if (this.showComments()) {
            this.kosub.subscribeChanged(global.login.selectedOrganization, this.initRequest.bind(this));
        }
        if (global.login.selectedOrganization()) {
            this.initRequest();
        }
    }

    private initRequest() {
        if (global.login.selectedOrganization()?.organizationid) {
            this.hash(getHash('customercommentsdetails', {orgnr: global.login.selectedOrganization()?.organizationid}));
        } else {
            this.hash(null)
        }
        this.req.abort()
        this.comments(null);
        this.req.request()
            .then((data: [ICompany]) => {
                this.comments(data[0]?.comment);
            })
    }

    private title = ko.pureComputed((): string => {
        if (this.req.isRequesting()) {
            return lm.t('loading data|td') ?? ''
        }
        const comments = this.comments();
        if (comments) {
            return comments;
        }
        return lm.t('no comment') ?? '';
    })

    private icon = ko.pureComputed((): string => {
        if (this.req.isRequesting()) {
            return 'fa-spinner fa-spin fa-fw';
        }
        const comments = this.comments();
        if (comments) {
            return this.routeDef.icon + ' fas';
        }
        return this.routeDef.icon + ' fal';
    })

    dispose() {
        this.kosub.unsuscribeAll();
        this.req.abort();
        pubsub.off(this);
    }

}
